import React from "react";

import Typography from "@material-ui/core/Typography";

import { PAD_NUMBER } from "../../utils/CommonFunctions";

class CountdownTimer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      time: ""
    };
  }

  componentDidMount() {
    const { countDownTo = "" } = this.props;
    let [hours, minutes] = countDownTo.split(":");
    let countDownDate = new Date();
    countDownDate.setHours(hours);
    countDownDate.setMinutes(minutes);
    countDownDate.setSeconds(0);
    var interval = setInterval(() => {
      // Get today's date and time
      var now = new Date().getTime();

      // Find the distance between now and the count down date
      var distance = countDownDate - now;

      // Time calculations for days, hours, minutes and seconds
      // var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      this.setState({
        time: `${PAD_NUMBER(hours, 2)}:${PAD_NUMBER(minutes, 2)}:${PAD_NUMBER(
          seconds,
          2
        )}`
      });

      // If the count down is over, write some text
      if (distance < 0) {
        clearInterval(interval);
        this.setState({ time: "" });
      }
    }, 1000);
  }

  render() {
    return (
      <Typography
        variant="body2"
        style={{
          fontSize: this.props.fontSize || "13px",
          fontWeight: "bold",
          color: "inherit"
        }}
      >
        {this.state.time}
      </Typography>
    );
  }
}

export default CountdownTimer;



// WEBPACK FOOTER //
// ./src/components/Utils/CountdownTimer.js